<template>
	<div class="bidirectional-text-label">
		<div class="bidirectional-text-label__content">
			<ShrinkText
				:text="text"
				:fontSize="14"
				isBold
				textClassList="bidirectional-text-label__text"
			/>
		</div>
		<BidirectionalLabelBackground
			:theme="theme"
			class="bidirectional-text-label__background"
		/>
	</div>
</template>

<script lang="ts" setup>
import ShrinkText from "@/components/ShrinkText.vue";
import BidirectionalLabelBackground from "@/components/SVG/BidirectionalLabelBackground.vue";
import { LabelThemes } from "@/types/ui";

interface Props {
	text: string;
	theme?: LabelThemes;
}

const { text, theme = LabelThemes.RED } = defineProps<Props>();
</script>

<style scoped lang="scss">
.bidirectional-text-label {
	display: flex;
	position: relative;
	width: 100%;

	&__content {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		padding: 0.25rem 1.25rem;
		width: 100%;
		height: 100%;
		@include flex-col-center;
	}

	:deep(.bidirectional-text-label__text) {
		padding-bottom: 0.125rem;
		color: #f4d278;
		text-shadow: 0.044rem 0.044rem 0.063rem rgba(0, 0, 0, 0.6);
		text-transform: uppercase;
	}

	// Note: background element defines size, so it's relative
	&__background {
		position: relative;
		z-index: 0;
		width: 100%;
	}
}
</style>
